import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import React, { ChangeEvent } from 'react'

interface IEditInviteEmailDialog {
  isOpen: boolean
  isLoading: boolean
  corporateName: string
  currentEmail: string
  email: string
  onChangeEmail: (email: string) => void
  onClose: () => void
  onConfirm: () => void
}

// Mesma checagem usada pelo AJV do projeto (`format: 'email'`): serve para
// evitar o request obviamente invalido, nao para validar o endereco de fato.
const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

const isValidEmail = (email: string) => EMAIL_PATTERN.test(email.trim())

const EditInviteEmailDialog: React.FC<IEditInviteEmailDialog> = ({
  isOpen,
  isLoading,
  corporateName,
  currentEmail,
  email,
  onChangeEmail,
  onClose,
  onConfirm,
}) => {
  const trimmedEmail = email.trim()
  const hasError = trimmedEmail !== '' && !isValidEmail(trimmedEmail)
  const isUnchanged = trimmedEmail === currentEmail.trim()

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => onChangeEmail(event.target.value)

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby='edit-invite-email-title'
      aria-describedby='edit-invite-email-description'
    >
      <DialogTitle id='edit-invite-email-title'>Editar e-mail do convite</DialogTitle>

      <DialogContent style={{ width: '500px' }}>
        <Alert
          severity='info'
          id='edit-invite-email-description'
          sx={{ marginBottom: '1rem' }}
        >
          Ao salvar, o convite de <strong>{corporateName}</strong> e reenviado imediatamente para o
          novo endereco, com um link novo. O link enviado antes deixa de valer.
        </Alert>

        <TextField
          autoFocus
          fullWidth
          size='small'
          type='email'
          variant='outlined'
          label='E-mail do convidado'
          value={email}
          onChange={handleChange}
          disabled={isLoading}
          error={hasError}
          helperText={hasError ? 'E-mail invalido' : ' '}
          inputProps={{ maxLength: 200 }}
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          variant='text'
          disabled={isLoading}
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant='contained'
          disabled={isLoading || isUnchanged || !isValidEmail(trimmedEmail)}
        >
          Salvar e reenviar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditInviteEmailDialog
